module.exports = __webpack_public_path__ + "static/weronikawork3-9eacb3a650f42ef2cf0e1cf1037bc648.jpg";